import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { richText } from '../../util/richText';
import { DraftContent } from '../../components';

import css from './ListingPage.module.css';
import classNames from 'classnames';

const MIN_LENGTH_FOR_LONG_WORDS_IN_DESCRIPTION = 20;

const SectionDescriptionMaybe = props => {
  const { description, offerDescription, isOffer } = props;

  if (isOffer) {
    return (
      <>
        {description && (
          <div className={css.sectionDescription}>
            <span className={css.label}>Description:</span>
            <span className={classNames(css.value, css.valueNotTransformed)}>
              <DraftContent draftContent={description} />
            </span>
          </div>
        )}
        {offerDescription && (
          <div className={css.sectionDescription}>
            <span className={css.label}>Offer Description:</span>
            <span className={classNames(css.value, css.valueNotTransformed)}>
              <DraftContent draftContent={offerDescription} />
            </span>
          </div>
        )}
      </>
    )
  } else {
    return (
      <>
        {description && (
          <div className={css.sectionDescription}>
            <h2 className={css.descriptionTitle}>
              Business Description
            </h2>
            <p className={css.description}>
              <DraftContent draftContent={description} />
            </p>
          </div>
        )}
      </>
    )
  }
};

export default SectionDescriptionMaybe;
